import moment from 'moment';
import axios from 'axios';
  export default {
    computed: {
        vendorCode () {
            const info = this.getVendorInfo();
            return info ? info.vendorCode : '';
        },
        vendorId () {
            const info = this.getVendorInfo();
            return info ? info.vendorId : '';
        }
    },
    data () {
        return {
            // vendorCode: () => JSON.parse(localStorage.getItem('supplierInfo')).vendorCode || '',
            // vendorId: () => JSON.parse(localStorage.getItem('supplierInfo')).vendorId || '',
            uploadFormat: ['xls', 'xlsx', 'doc', 'docx', 'jpeg', 'jpg', 'png', 'gif', 'pdf', 'txt', 'xml', 'rar', 'zip', '7z']
        };
    },
    methods: {
        getFormDataItemVal(obj, key) {
            let value;
            obj.map((item) => {
            if (item.field === key) {
                value = item.value;
            }
            });
            return value;
        },
        getFormDataItemObj(obj, key) {
            let newObj;
            obj.map((item) => {
            if (item.field === key) {
                newObj = item;
            }
            });
            return newObj;
        },
        getFormDataVModel(obj, filter = false) {
            let newObj = {};
            obj.map((item) => {
            if (item.type === 'datePicker' || item.type === 'date') {
                newObj[item.field] = item.value ? moment(new Date(item.value)).format(item.options.format.toUpperCase()) : '';
            } else {
                if (!filter) {
                newObj[item.field] = item.value;
                } else {
                newObj[item.field] = item.value ? item.value : undefined;
                }
            }
            });
            return newObj;
        },
        showErrorTips (key = 'loading', msg) {
            this[key] = false;
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: msg || this.$t('common.error1')
            });
        },
        showSuccessTips (key = 'loading', msg) {
            this[key] = false;
            this.$Modal.success({
                title: this.$t('common.warn'),
                content: msg || this.$t('common.save_success')
            });
        },
        // 获取快码接口
        getDict (dictCode, callBack = null) {
            return axios.get('/gscint/sys/sysParam/queryDictionaryData', {
                params: {
                    dictCode,
                    isValid: 'Y'
                }
            })
            .then((res) => {
                let data = res.data.data;
                // 英文字典切换
                if (data) {
                    if (this.$i18n.locale !== 'zh-CN') {
                        data.map((item) => {
                            item.label = item.valueEn || item.label;
                            return item;
                        });
                    }
                    this[dictCode] = data;
                }
                callBack && callBack(data);
            });
        },
        // 库存组织
        getSRMInvLovListNew (callBack = null) {
            return axios.get('/gscint/vendor/getSRMInvLovListNew', {
                params: {
                    UP: 'Y',
                    SITE: 'Y',
                    ASL: 'N',
                    INTL: 'Y'
                }
            })
            .then((res) => {
                let data = res.data.data;
                if (data) {
                    if (callBack) {
                    callBack(data);
                    }
                }
            });
        },
        // 转换语言参数
        switchLanguage (lang) {
            switch (lang) {
                case 'zh-CN':
                    return 'ZHS';
                    break;
                case 'en-US':
                    return 'US';
                    break;
                case 'th':
                    return 'TH';
                    break;
                default:
                    return 'US';
            }
        },
        isPro () {
            return window.environment.isPro;
        },
        /* 判断是否包含指定的字符串 */
        containsAnyOf(str, patterns) {
            const regex = new RegExp('(' + patterns.join('|') + ')');
            return regex.test(str);
        },
        /* 云打印 */
        cloudPrint (tempCode, reportlets, exportParam={}) {
            const isOb = this.containsAnyOf(window.location.hostname, ['gscob', 'gschkuat', 'gschk', 'gsc-hk']);
            const NODE_ENV = process.env.NODE_ENV;
            const mPintUrl = {
                development: 'https://apiuat.midea.com/T-LPAAS/logistics-paas-printer/pdf/token/',
                sit: 'https://apisit.midea.com/T-LPAAS/logistics-paas-printer/pdf/token/',
                uat: 'https://apiuat.midea.com/T-LPAAS/logistics-paas-printer/pdf/token/',
                production: 'https://apiprod.midea.com/T-LPAAS/logistics-paas-printer/pdf/token/',
                isHk: '/T-LPAAS/logistics-paas-printer/pdf/token/',
            };
            const tenantCode = {
                development: 'T457883764',
                sit: 'T457883764',
                uat: 'T457883764',
                production: 'T817364564'
            }
            const userCode = {
                development: 'MC826670689',
                sit: 'MC826670689',
                uat: 'MC826670689',
                production: 'MC564822814'
            }
            let params = {
                tempCode,
                tenantCode: tenantCode[NODE_ENV],
                userCode: userCode[NODE_ENV]
            }
            const url = isOb ? mPintUrl.isHk : mPintUrl[NODE_ENV];
            return axios.get(`${url}${Object.values(params).join('/')}`)
            .then((res) => {
                let {code, data} = res.data;
                let {exportType, fileName} = exportParam;
                let url = '';
                if (exportType === 'excel') {
                    url = data.pdfUrl ? data.pdfUrl.replace('/pdf', `/${exportType}`) : '';
                } else {
                    url = data.pdfUrl;
                }
                if (code === '0') {
                    url = isOb ? url.replace('https://gscuat.midea.com/', '/') : url;
                    /* gsc-hk域名特殊处理 */
                    if (location.hostname.indexOf('gsc-hk') > -1) {
                        url = url.replace('gschk', 'gsc-hk');
                    }
                    return axios.post(url,
                        {
                            ...reportlets
                        },
                        {
                            responseType: 'blob',
                            headers: { 
                                'Content-Type': 'application/json;charset=UTF-8' 
                            }
                        }
                    )
                    .then((res) => {
                        let a = document.createElement('a');
                        if (fileName) {
                            a.download=`${fileName}`;
                        }
                        a.href = window.URL.createObjectURL(res.data);
                        a.target = '_blank';
                        document.body.appendChild(a);
                        a.click();
                    });
                } else {
                    this.showErrorTips('token获取异常');
                } 
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        /* 是否调用云打印
            @param data 打印数据
            @param orgCode 组织
            @param vendorCode 供应商code
            @param cpts 父子模板可用参数
            @param cpt 打印模板
        */
        isCloundPrint (data, orgCode, vendorCode, cpts, cpt) {
            let flag = false;
            let obj = this.$store.state.CUX_PRINT_FORMWORK.find((item) => cpt === item.code);
            if (obj) {
                /* 全部启动 */
                if (obj.label === 'Y') {
                    flag = true;
                } else {
                    /* 供应商、组织同时满足 */
                    if (obj.attribute1 && obj.value) {
                        if (obj.attribute1.indexOf(orgCode) > -1 && obj.value.indexOf(vendorCode) > -1) {
                            flag = true;
                        }
                    /* 组织满足 */
                    } else if (obj.attribute1 && !obj.value) {
                        if (obj.attribute1.indexOf(orgCode) > -1) {
                            flag = true;
                        }
                    /* 供应商满足 */
                    } else if (!obj.attribute1 && obj.value){
                        if (obj.value.indexOf(vendorCode) > -1) {
                            flag = true;
                        }
                    }
                }
            }
            if (flag) {
                this.cloudPrint(cpt, data);
            }
            return flag;
        },
        // 快码
        getDictByCode (code, callback = undefined) {
            return axios.get(`/gscint/sys/sysParam/queryDictionaryData?dictCode=${code}&isValid=Y`)
            .then((res) => {
                let data = res.data.data;
                if (data) {
                    this[code] = data;
                    if (callback) {
                        callback(data);
                    }
                }
            });
        },
        qmsLanguageChange () {
            let lang = {
                'zh-CN': 'zh-cn',
                'en-US': 'en_us',
                'th': 'en-th'
            }
            return lang[this.$i18n.locale];
        },
        qmsLanguageChange2 () {
            let lang = {
                'zh-CN': 'ZH-CN',
                'en-US': 'EN-US',
                'th': 'EN-US'
            }
            return lang[this.$i18n.locale];
        },
        // 下载文件流
        downloadFile (data, filename) {
            if (!data) {
                return;
            }
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        getUserBaseInfo (callBack = null) {
            return axios.post('/gscint/vendor/getCurrentVendor').then(res => {
                callBack && callBack(res);
            });
        },
        queryVendorAndMdm (vendorCode, callBack = null) {
            return axios.post('/gscint/vendor/queryVendorAndMdm', {
                vendorCode
            })
            .then((res) => {
                callBack && callBack(res.data.data.datas.mdmCode)
            });
        },
        getVendorInfo () {
            return JSON.parse(localStorage.getItem('supplierInfo'));
        }
    },
  };